import { useFeatureFlagEnabled } from 'posthog-js/react'

import { FeatureFlag } from '@/lib/posthog/features'

export const useFlag = (name: FeatureFlag): boolean | undefined => {
  return useFeatureFlagEnabled(name.toString())
}
